module.exports = __webpack_public_path__ + "img/gb-wls.b9612e1.svg";